import { WHATS_NEW_PARAM } from './useWhatsNewUrl';

/**
 * Reloads the page without the panel parameter (the panel "Reload"), so the new build does not
 * open the panel of the version that the person just read.
 */
export function reloadPageWithoutPanel(): void {
  const url = new URL(window.location.href);
  url.searchParams.delete(WHATS_NEW_PARAM);
  window.location.replace(url.toString());
}
